import styled from 'styled-components'

export const Section = styled.section`
  width: 100%;
  background: #fff;
  margin-top: 124px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 18px;
`

export const Title = styled.h2`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 36px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  color: #21105d;
  margin-bottom: 40px;
  @media (max-width: 600px) {
    font-size: 24px;
  }
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 40px;
  justify-content: center;
  width: 100%;
  max-width: 1200px;
  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
    gap: 32px;
  }
`

export const ImageCol = styled.div`
  flex: 1 1 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 280px;
  @media (max-width: 900px) {
    min-width: unset;
    width: 100%;
    margin-bottom: 24px;
  }
`

export const TextCol = styled.div`
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  gap: 48px;
  min-width: 280px;
  max-width: 600px;
  color: #21105d;
  @media (max-width: 900px) {
    min-width: unset;
    max-width: unset;
    width: 100%;
  }
  @media (max-width: 600px) {
    gap: 12px;
    align-items: flex-start;
  }
`

export const Block = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
`

export const BlockTitle = styled.b`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 21px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #21105d;
  @media (max-width: 600px) {
    font-size: 16px;
  }
`

export const BlockText = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #21105d;
  @media (max-width: 600px) {
    font-size: 12px;
    line-height: 18px;
  }
`
